import {useMutation, UseMutationResult} from '@tanstack/react-query';
import queryString from 'query-string';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {DocumentType} from 'types/documents';
import {request} from 'utils/request';

export type CustomTemplateItem = {
    baseTemplateCode: string;
    displayName: string;
    documentType: string;
    draft: boolean;
    filename: string;
    mid: string;
    partner: {
        mid: string;
        name: string;
        url: string;
    };
    templateFileUrl: string;
    uploadedFileUrl: string;
    url: string;
};

export type SearchRequest = {
    keyword: string;
    page?: number;
};

export type CustomTemplateSearchApiResult = {
    pagination: {
        currentPage: number;
        endCount: number;
        numPages: number;
        startCount: number;
        totalCount: number;
    };
    request: SearchRequest;
    results: CustomTemplateItem[];
};

export const useGetCustomTemplateSearchResult = (): UseMutationResult<
    Api.Response.Success<CustomTemplateSearchApiResult>,
    Api.Response.Failure<{[K in DocumentType]: boolean}>,
    {mid: string} & SearchRequest
> => {
    const locale = useLocale();

    return useMutation(({mid, ...rest}) =>
        request({
            locale,
            method: 'GET',
            uri: `/api/partner/${mid}/custom-template/search/?${queryString.stringify(
                rest,
            )}`,
        }),
    );
};
